
/*
Author: Vinod
Date: 27/03/2020
Issue Description: Get api is getting called two times
search_string: PL_2989
*/

/*
Author: Vinod
Date: 06/04/2020
Issue Description: Not showing employees in UI, even if coming from backend.
search_string: PL_3031
*/

/*
Author: Vinod
Date: 07/04/2020
Issue Description: Able to see the same employee Multiple times.
search_string: PL_3040
*/

<template>
  <div class="main-container">
    <tl-header type="h1">
      <div>Employees</div>
    </tl-header>
    <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
      You have only view permission.
    </div>
    <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
    <div v-if="!employeeData.length">
      <div class="noData" v-show="ifTeamleaderAnchorPermission">
        <span>
          You have not added any Employee yet.
          <br />Click on below button to add employees.
        </span>
      </div>
    </div>
    <div v-else>
      <div class="add-btn-small" v-show="ifTeamleaderAnchorPermission">
        <div class="search-container">
          <tl-search @change="filterData($event)" />
        </div>

        <!-- Working on bulk upload employee code update part 1 -->
        <!-- <div class="update-emp-code-btn" @click="bulkUploadCode()">Employee Code Update Through Bulk</div> -->
        <!-- End here bulk upload employee code update  part 1 -->

        <button class="addnewbtn" v-if="employeeData.length>3" @click="createForm()">
          <img src="@/assets/group-5.svg" />
          <b>Add New</b>
        </button>
      </div>

      <!-- Working on bulk upload employee code update  part 2 -->
      <div class="bulkUploadClass margin-l-l mt-2 mb-3" v-if="bulkUploadEmpCode">
        <div class="download-btn mb-3">
          <!-- PL_2457 -->
          <download-button @downloadTemplate="getEmployeeCodeTemplate()"></download-button>
        </div>
        <div :key="componentKey">
          <upload-file :apiUrl="bulkUploadUrl" @uploadTemplate="onUploadTemplate($event)" />
        </div>
      </div>

      <div>{{employeeData.length}}&nbsp;/&nbsp;{{totalEmployees}}</div>
      <div class="table-div" ref="table_div" @scroll="onScroll()">
        <data-table :columns="employeeTableColumns" :tableData="employeeData" :showinrow="true" :with-form="false"
          :showhistory="false" :showdelete="false" @editStart="initEditStart" :disabled="!ifTeamleaderAnchorPermission">
          <template v-slot:rowcontent="slotprops">
            <p class="proxy-container" v-if="slotprops.value.column.key == 'proxy'">
              <img src="@/assets/arrow-pointing-to-right.svg" class="cross-circle-img"
                @click="editPermission(slotprops.value.record)" alt="actionIcon" style="margin:0px 10px;" />
            </p>
          </template>
        </data-table>
      </div>
      <!-- <toast-message :message="this.errmsg" v-show="this.toast" type="error" /> -->
    </div>
    <form-add-button v-if="employeeData.length<=3" main_text="+ Add New" sub_text="Employee" @click="createForm()"
      v-show="ifTeamleaderAnchorPermission"></form-add-button>
    <pop-up-message v-if="showBulkUploadSuccessMsg" :message="`${popupMessage}`" btnText="Back"
      @back="back"></pop-up-message>
    <bottom-action-container>
      <!-- <btn-skip @navClicked="continuee"></btn-skip> -->
      <template slot="end">
        <btn-grp>
          <btn text="Previous" type="secondary" @click="previous" />
          <btn text="Proceed" type="primary" @click="goToDashboard" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { api_variables } from "@/apis/variables.js";
import axios from 'axios';

export default {
  data() {
    return {
      currentObj: {},
      clientCode:"",
      token_one:"",
      popupType: "ConfirmDelete",
      showConfirmDelete: false,
      toast: false,
      errmsg: "",
      page: 1,
      totalEmployees: 0,
      locationList: [],
      designationList: [],
      employeeData: [],
      employeeTableColumns: [
        {
          label: "Employee Code",
          key: "code"
        },
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Locations",
          key: "location"
        },
        {
          label: "Designation",
          key: "designation"
        },
        {
          label: "",
          key: "proxy"
        }
      ],
      addEmployeeValue: false,
      role: "",
      tempList:[],
      bulkUploadEmpCode: false,
      bulkUploadUrl: api_variables.SERVICE_EMPLOYEE_CODE_BULK_UPLOAD,
      popupMessage: "",  
      showBulkUploadSuccessMsg: false,
    };
  },
  activated() {
    this.page = 1;
    this.toast = false;
    this.employeeData = [];
    this.getLocations();
    this.getDesignation();
    this.fetchemp();
    this.getOrgLeIdList();
    this.getStepperStatus();
  },
  // PL_2989
  mounted() {
    this.toast = false;
    this.employeeData = []; //  PL_3040
    this.getOrgLeIdList();
    this.getStepperStatus();
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),

    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ...mapState("onboard/organization", {
      orgIds: state => state.id,
    }),
    ifTeamleaderAnchorPermission() {
      if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
        if(this.addEmployeeValue) {
        return true;
        } else {
          return false;
        }
      } 
      // else {
      //  return true 
      // }
    },
  },
  methods: {

    /* to map all actions from the stores */
    ...mapActions({
      act_fetch: "onboard/employees/fetchAll",
      fetchLocations: "onboard/locations/fetchAll",
      fetchDesignation: "onboard/designations/fetchAll"
    }),

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
      fetch_template: "onboard/employees/getEmployeeCodeTemplate",
      act_proxyMode: "onboard/employees/getProxy",
      act_fetch_stepper_status: "onboard/legal_entities/fetchStepperStatus",
      act_set_user_role: "auth/setUserRoleFromProxy"
    }),


    async editPermission(record) {
      try {
        let payload = {
          identity: record.code,
          companyCode: this.clientCode,
        }
        this.token_one = localStorage.getItem("token")
        localStorage.setItem('token1', this.token_one)
        let res = await this.act_proxyMode(payload)
        const userrole = localStorage.getItem("userRole")
        localStorage.setItem("userRole1", userrole)
        const loginId = localStorage.getItem("loginId")
        localStorage.setItem("loginId1", loginId)
        const employeeId = localStorage.getItem("employeeId")
        localStorage.setItem("employeeId1", employeeId)
        if (res && res.status) {
          localStorage.setItem("loginId", res.data.payload.email);
          localStorage.setItem("token", res.data.payload.token);
          localStorage.setItem("userRole", res.data.payload.userRole);
          let role = res.data.payload.userRole
          this.act_set_user_role(role);
          if (res.data.payload.userRole === 'HR' || res.data.payload.userRole === 'EMPLOYEE') {
            let orgId = res.data.payload.org_id;
            const permissionOrgs = res.data.payload.le_id;
            localStorage.setItem("le_id", res.data.payload.le_id);
            localStorage.setItem("empId", res.data.payload.employee_id);
            setTimeout(() => {
              this.$router.push({ path: `/dashboard/0/overview/feed`, replace: true });
              window.location.reload();
            }, 100);
          }
          else if (res.data.payload.userRole === 'CLIENTADMIN' ) {
            let orgId = res.data.payload.org_id;
            const permissionOrgs = res.data.payload.le_id;
            localStorage.setItem("le_id", res.data.payload.le_id);
            localStorage.setItem("empId", res.data.payload.employee_id);
            localStorage.setItem("ecode", res.data.payload.ecode);
            localStorage.setItem("companycode", res.data.payload.comapnyCode)
            setTimeout(() => {
              this.$router.push({ path: `/clientOrgSummary`, replace: true });
              window.location.reload();
            }, 100);
          }
        }
        else
          throw "ESS Not Enabled for this Employee"
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    async getStepperStatus() {
      try {
        let res = await this.act_fetch_stepper_status({ le_id: this.le_id, index: this.$route.params.entity_index });
        this.clientCode = res.data && res.data.payload && res.data.payload.data[0] && res.data.payload.data[0].LegalEntity.clientCode
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* server call to get locations for current Legal Entity */
    async getLocations() {
      try {
        let res = await this.fetchLocations(this.le_id);
        if (res.data.status) {
          this.locationList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get designations for current Legal Entity */
    async getDesignation() {
      try {
        let res = await this.fetchDesignation(this.le_id);
        if (res.data.status) {
          this.designationList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get Employees for current Legal Entity */
    async fetchemp() {
      try {
        let res = await this.act_fetch({ le_id: this.le_id, page: this.page });
        if (res.data.status) {
          let empList = [];
          this.totalEmployees = res.data.payload.total;
          res.data.payload.data.forEach(element => {
            empList.push({
              id: element.id,
              name:
                element.first_name +
                " " +
                (element.last_name ? element.last_name : ""),
              code: element.code,
              location: element.EmployeeOfficial
                ? this.getLocationName(element)
                : "",   // PL_3031
              designation: element.EmployeeOfficial
                ? this.getDesignationName(element)
                : ""    // PL_3031
            });
          });
          this.employeeData.push(...empList);
          this.tempList = this.employeeData;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to get Employees on scroll */
    onScroll() {
      let bottomOfWindow =
        this.$refs.table_div.scrollHeight - this.$refs.table_div.scrollTop <=
        this.$refs.table_div.offsetHeight;
      if (bottomOfWindow && this.employeeData.length < this.totalEmployees) {
        this.page += 1;
        this.fetchemp();
      }
    },

    /* function to get location name based on location id */
    getLocationName(element) {
      let location = this.locationList.find(item => {
        if (!element.EmployeeOfficial) return false;
        else return item.id == element.EmployeeOfficial.based_location_id;
      });
      return location ? location.name : "";
    },

    /* function to get designation name based on designation id */
    getDesignationName(element) {
      let designation = this.designationList.find(
        item => item.id == element.EmployeeOfficial.designation_id
      );
      return designation ? designation.name : "";
    },

    /* function to navigate to add employee/s */
    createForm() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/${this.$route.params.step_name}/addEmployee`
      });
    },

    /* function to edit an employee */
    initEditStart(rec) {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/${this.$route.params.step_name}/editEmployee`,
        query: { id: rec.id }
      });
    },

    /* function to go previous page */
    previous() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/fbpEligibility`
      });
    },

    /* function to go to dasboard */
    goToDashboard() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/legacyData`
      });
    },

    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.le_id;
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.addEmployeeValue = data.data.user.permissions.add_employee ? true : false;
    },

    /* function to search in local by name */
    filterData(val) {
      try {
        let tempArray = [];

        this.tempList.forEach(element => {
          if (element['name'] || element['code']) {
            if (element['name'].toUpperCase().indexOf(val.toUpperCase()) > -1 || element['code'].toUpperCase().indexOf(val.toUpperCase()) > -1) {
              tempArray.push(element);
            }
          }
        });
        if (val) {
          if(tempArray.length>0){
          this.toast = false
          this.employeeData = tempArray;
          }
          else{
            this.toast = true;
            this.errmsg = "Employee code/name is invalid"
          }
        }else {
          this.employeeData = this.tempList;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    bulkUploadCode() {
      this.bulkUploadEmpCode = true;
    },

    async getEmployeeCodeTemplate() {
      try {
        let res = await this.fetch_template(this.le_id);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /** BULK UPLOAD server call response handling */
    async onUploadTemplate(res) {
      try {
        if (res.data || res.status) {
          this.popupMessage = res.data.message ? res.data.message : "";
          this.showBulkUploadSuccessMsg = true;
        } else {
          this.toast = true;
          this.errmsg = res.message;
        }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },

    back() {
      try {
        this.showBulkUploadSuccessMsg = false;
        this.bulkUploadEmpCode = false;
        this.$router.go(0);
        // this.$router.push({
        //   path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
        // });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.cross-circle-img{
  height: 20px;
}
.proxy-container{
  opacity: 0;
}
.proxy-container:hover {
    opacity: 1;
}
.table-div {
  min-height: 350px;
  // max-height: 500px;
  margin-bottom: 175px;
  overflow: auto;
}
.add-btn-small {
  height: auto;
  padding: 10px;
  display: flex;
  justify-content: space-between;   // Before attribute:flex-end
  align-items: center;
  .text {
    color: #858585;
    font-size: 14px;
  }
}

.employee-info {
  height: 150px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  padding: 20px 15px 20px 25px;
  position: relative;
  &:nth-child(n) {
    margin-right: 20px;
  }
  .btn-primary-small {
    background-color: white;
    color: $color-primary;
    border-radius: 4px;
    border: 1px solid $color-primary;
    height: 25px;
    padding: 0px 20px;
    font-size: $font-size-small;
    width: auto;
  }

  .header-text {
    font-size: 24px;
    font-weight: bold;
    color: $color-secondary;
  }
  .sub-text {
    font-size: 20px;
    color: $color-primary;
    margin-top: 20px;
  }
  .btn-upload {
    position: absolute;
    bottom: 20px;
    right: 15px;
  }
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
  span {
    color: #858585;
    font-size: 18px;
  }
}
.action-container {
  margin-left: auto;
  display: flex;
  justify-content: flex-end;
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
}
.noData span {
  font-size: 18px;
  color: #858585;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}

.update-emp-code-btn {
  border: 1px solid #34c0be;
  border-radius: 4px;
  padding: 6px 10px;
  font-weight: bold;
  color: #34c0be;
  height: 35px;
  line-height: 20px;
  cursor: pointer;
}
</style>
